jQuery(document).ready(function($) {

  if ('undefined' !== typeof FWP) {
      // FWP.auto_refresh = false;
  }

  /// add dimming class to product listings while facets are being applied ///
  $(document).on('facetwp-refresh', function() {
    if (FWP.loaded) {
      $('.facetwp-template').addClass('dimmed');
    }
  });
  /// -------------------------------------------------------------------- ///

  /// remove dimming class from product listings after facets are applied ///
  $(document).on('facetwp-loaded', function() {
    if (FWP.loaded) {
      $('.facetwp-template').removeClass('dimmed');
    }
  });
  /// -------------------------------------------------------------------- ///

  /// force page reload on facetwp change ///
  // $(document).on('facetwp-refresh', function() {
  //   if (FWP.loaded) {
  //     FWP.set_hash();
  //     window.location.reload();
  //     return false;
  //   }
  // });
  /// END: force page reload on facetwp change ///


  window.print_this = function(id) {
    var prtContent = document.getElementById(id);
    var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

    WinPrint.document.write('<link rel="stylesheet" type="text/css" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">');

    // To keep styling
    /*var file = WinPrint.document.createElement("link");
    file.setAttribute("rel", "stylesheet");
    file.setAttribute("type", "text/css");
    file.setAttribute("href", 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css');
    WinPrint.document.head.appendChild(file);*/

    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.close();
    WinPrint.setTimeout(function(){
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }, 1000);
  }


  /*=== Image Zoomies ===*/
  $('.woocommerce-product-gallery__image img').attr('data-action', 'zoom');


  /*=== Box Size ===*/
  boxsize('.heightresize')

  /*=== Menu classes ===*/
  jQuery('.menu_icon.left').click(function() {
    if (jQuery('.res_menu_right_container').hasClass('anime')) {
      jQuery('.res_menu_right_container').removeClass('anime')
    } else {
      jQuery('.res_menu_left_container').addClass('anime')
    }
  })

  jQuery('.left_close').click(function() {
    jQuery('.res_menu_left_container').removeClass('anime')
  })

  jQuery('.menu_icon.right').click(function() {
    if (jQuery('.res_menu_left_container').hasClass('anime')) {
      jQuery('.res_menu_left_container').removeClass('anime')
    } else {
      jQuery('.res_menu_right_container').addClass('anime')
    }
  })

  jQuery('.right_close').click(function() {
    jQuery('.res_menu_right_container').removeClass('anime')
  })

  /*=== Sub Menu ===*/
/*
  jQuery('nav ul').superfish({
    delay: 300,
    animation: { opacity: 'show', height: 'show' },
    speed: 'fast',
    autoArrows: false
  })
*/
  /*=== Accordion ===*/
  jQuery('.left_menu_accordion').accordion({
    active: false,
    animate: 800,
    collapsible: true
  })

  if (jQuery('#accordion').length) {
    jQuery('#accordion').accordion({
      active: false,
      animate: 800,
      collapsible: true
    })
  }

  jQuery('#accordion_tabs.res').accordion({
    active: false,
    animate: 800,
    collapsible: true
  })

  /*=== Tabs ===*/
  jQuery('#responsiveTabs_posts').responsiveTabs({
    startCollapsed: 'accordion',
    animate: 800
  })

  jQuery('.tabs_forms').responsiveTabs({
    startCollapsed: 'accordion',
    animate: 800
  });

  /*
  jQuery('a[href*=#]:not([href=#])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
        || location.hostname == this.hostname) {

        var target = jQuery(this.hash);
        target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
         if (target.length) {
           jQuery('html,body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  */

  /*
  function animatecontent(ele, modifier) {
    var sl = ele.scrollLeft()
    ele.animate(
      {
        scrollLeft: sl + modifier * 120
      },
      450,
      'linear',
      function() {
        if (hover) {
          animatecontent(ele, modifier)
        }
      }
    )
  }
  var hover = false
  jQuery('.scroll-arrow').each(function() {
    var modifier = jQuery(this).hasClass('right') ? 1 : -1
    var sib = '.shelf-slide'
    jQuery(this).hover(
      function() {
        hover = true
        jQuery(this)
          .siblings(sib)
          .stop()
        animatecontent(jQuery(this).siblings(sib), modifier)
      },
      function() {
        hover = false
        jQuery(this)
          .siblings(sib)
          .stop()
      }
    )
  })
  */

  /*=== Plus Minus Quantity ===*/
  if (!jQuery('.plusminusbutton').length) return
  jQuery('.plusminusbutton').on('click', function() {
    var oldValue = jQuery(this)
        .parent()
        .find('.input-text.qty')
        .val(),
      newVal = 0
    if (jQuery(this).hasClass('plus')) newVal = parseFloat(oldValue) + 1
    else if (oldValue > 0) newVal = parseFloat(oldValue) - 1
    $(this)
      .parent()
      .find('.input-text.qty')
      .val(newVal)
      .trigger('input')
  })
})

jQuery(window).resize(function() {
  /*=== Animate on scroll ===*/
  AOS.init({
    disable: 'mobile'
  })

  /*=== Box Size ===*/
  boxsize('.heightresize')

  /*=== Scroll Menu ===*/
})

jQuery(window).load(function() {
  /*=== Popup form ===*/
  jQuery('.popup-with-form').magnificPopup({
    type: 'inline',

    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: 'auto',

    closeBtnInside: true,
    preloader: false,

    midClick: true,
    removalDelay: 300,
    mainClass: 'my-mfp-slide-bottom'
  })

  /*=== Sticky Sidebar ===*/
  jQuery('.tabs_inner ul').stickySidebar({ topSpacing: 0 })


/*
  var topMenu = jQuery('.tabs_inner ul'),
    offset = 40,
    topMenuHeight = topMenu.outerHeight() + offset,
    // All list items
    menuItems = topMenu.find('a[href*="#"]'),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function() {
      var href = jQuery(this).attr('href'),
        id = href.substring(href.indexOf('#')),
        item = jQuery(id)
      //console.log(item)
      if (item.length) {
        return item
      }
    })

  // so we can get a fancy scroll animation
  menuItems.click(function(e) {
    var href = jQuery(this).attr('href'),
      id = href.substring(href.indexOf('#'))
    offsetTop = href === '#' ? 0 : jQuery(id).offset().top - topMenuHeight + 1
    jQuery('html, body')
      .stop()
      .animate(
        {
          scrollTop: offsetTop
        },
        300
      )
    e.preventDefault()
  })


  // Bind to scroll
  jQuery(window).scroll(function() {
    // Get container scroll position
    var fromTop = jQuery(this).scrollTop() + topMenuHeight

    // Get id of current scroll item
    var cur = scrollItems.map(function() {
      if (jQuery(this).offset().top < fromTop) return this
    })

    // Get the id of the current element
    cur = cur[cur.length - 1]
    var id = cur && cur.length ? cur[0].id : ''

    menuItems.parent().removeClass('active')
    if (id) {
      menuItems
        .parent()
        .end()
        .filter("[href*='#" + id + "']")
        .parent()
        .addClass('active')
    }
  })
*/

  /*=== Slick Slide ===*/
  jQuery('.h_slide_container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    responsive: [
      {
        breakpoint: 901,
        settings: {
          centerMode: true,
          infinite: false,
          centerPadding: '30px',
          slidesToShow: 1,
          dots: true,
          fade: false,
          setPosition: 0
        },
        breakpoint: 651,
        settings: {
          centerMode: true,
          infinite: false,
          centerPadding: '0',
          slidesToShow: 1,
          dots: true,
          fade: false,
          setPosition: 0
        }
      }
    ]
  })

  /*=== Testimonial Slide ===*/
  jQuery('.testimonial_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    responsive: [
      {
        breakpoint: 901,
        settings: {
          centerMode: true,
          infinite: false,
          centerPadding: '30px',
          slidesToShow: 1,
          dots: true,
          fade: false,
          setPosition: 0
        },
        breakpoint: 651,
        settings: {
          centerMode: true,
          infinite: false,
          centerPadding: '0',
          slidesToShow: 1,
          dots: true,
          fade: false,
          setPosition: 0
        }
      }
    ]
  })

  jQuery('.recipe_slide_big').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: true,
    autoplay: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true,
          autoplay: false,
      dots: false,
          infinite: false

        }
      }
    ]
  })

  jQuery('.recipe_slide_bg.res').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    infinite: false,
    centerPadding: '60px',
    slidesToShow: 1,
    dots: false,
    arrows: true,
    fade: false,
    setPosition: 0,
  responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          autoplay: false,
      dots: false,
          infinite: false

        }
      }
    ]
  })

  jQuery('.right_nav_slide_container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    setPosition: 0,
    prevArrow: jQuery('.slick_prev'),
    nextArrow: jQuery('.slick_next'),
    asNavFor: '.right_slide_nav'
  })

  jQuery('.right_slide_nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '.right_nav_slide_container',
    dots: true,
    centerMode: true,
    focusOnSelect: true
  })

  jQuery('.offset_slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000
  })

  jQuery('.recipe_slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    fade: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000
  })

  jQuery('.top_picks_featured').slick({
    slidesToShow: 4,
    arrows: true,
    dots: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
      arrows: true,

        },
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
      arrows: true,
        }
      }
    ]
  })
  /**/
  jQuery('.product_benefits_slider').slick({
    slidesToShow: 3,
    arrows: true,
    dots: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
      arrows: true,
      dots: false

        },
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
      arrows: true,
      dots: false

        }
      }
    ]
  })
  /**/




  jQuery('.two_slide').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]

  })

  jQuery('.single_slide').slick({
    slidesToShow: 1,
    arrows: false,
    dots: true
  })

  jQuery('.post_style_slide').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    setPosition: 0,
    fade: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000
  })

  jQuery('.tabbed').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    setPosition: 0,
    fade: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000
  })

  jQuery('.we_are_slide .offset_list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: true
  })

  jQuery('.instagram-pics').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 2,
    arrows: false,
    dots: false,
    autoplay: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        },
        breakpoint: 651,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  })

  jQuery('.rec_left').click(function() {
    jQuery('.recipe_slide').slick('slickPrev')
  })

  jQuery('.rec_right').click(function() {
    jQuery('.recipe_slide').slick('slickNext')
  })

  /*=== Body Class ===*/
  jQuery('body').addClass('loaded')

  /*=== Animate on scroll ===*/
  if (jQuery('body').hasClass('loaded')) {
    AOS.init({
      disable: 'mobile'
    })
  }

  /*=== Box Size ===*/
  boxsize('.heightresize')
})

if (
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
) {
  //xx
}

/*=== Box Height ===*/
function boxsize(el) {
  var highestBox = 0

  jQuery(el).each(function() {
    jQuery(this).outerHeight('auto')
  })

  if (jQuery(window).width() < 400) return

  jQuery(el).each(function() {
    if (jQuery(this).outerHeight() > highestBox)
      highestBox = jQuery(this).outerHeight()
  })

  jQuery(el).outerHeight(highestBox)

  return true
}

jQuery(document).load(function() {
  if (window.location.hash) {
    var hash = window.location.hash
    jQuery('html, body').animate(
      {
        scrollTop: jQuery(hash).offset().top
      },
      500
    )
  }
})



jQuery(document).ready(function ($) {
  jQuery(document).on("scroll", onScroll);

  //smoothscroll
  jQuery('.cat_list li a[href^="#"]').on('click', function (e) {
      e.preventDefault();
      jQuery(document).off("scroll");

      jQuery('a').each(function () {
          jQuery(this).removeClass('active');
      })
      jQuery(this).addClass('active');

      var target = this.hash,
          menu = target;
      $target = jQuery(target);
      jQuery('html, body').stop().animate({
          'scrollTop': $target.offset().top + 2
      }, 500, 'swing', function () {
          window.location.hash = target;
          jQuery(document).on("scroll", onScroll);
      });
  });



});

function onScroll(event){
  var scrollPos = jQuery(document).scrollTop();
  jQuery('.inner-wrapper-sticky a').each(function () {
      var currLink = jQuery(this);
      var refElement = jQuery(currLink.attr("href"));
      if (refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
          jQuery('.inner-wrapper-sticky a').removeClass("active");
          currLink.addClass("active");
      }
      else{
          currLink.removeClass("active");
      }
  });
}






//////////////////////////////////////////////////
/////////////////////////////////////////////////
///// Hacky LSEP character fix at runtime //////
///////////////////////////////////////////////
//////////////////////////////////////////////

// jQuery(document).ready(function ($) {
//   console.log('testing 123 blah!');
//   $("body").children().each(function() {
//     $(this).html($(this).html().replace(/&#8232;/g," "));
//   });
// });


/////////////////////////////////
////////////////////////////////
///// MOBILE SEARCH LINK //////
//////////////////////////////
/////////////////////////////

(function($) {
  $(window).ready(function() {
    $(".desktop_search .search_img a").click(function(e){
       e.preventDefault();

       $(".desktop_search .header_search_form .dgwt-wcas-search-form").show('slide', {direction: 'right'}, 'slow');
       $(this).hide();
    });

    $(".mobile_search_link .search_img a").click(function(e){
      e.preventDefault();
      $(".mobile_search_form").toggle();

      $(".mobile_search_form .header_search_form .dgwt-wcas-search-form .dgwt-wcas-search-input").focus();
    });


      $(".desktop_search .header_search_form .dgwt-wcas-search-form .dgwt-wcas-suggestions-wrapp").focusout(function() {
      $('.desktop_search .header_search_form .dgwt-wcas-search-form').hide();
      $(".desktop_search .search_img a").show();
    });


    $(".mobile_search_form .header_search_form .dgwt-wcas-search-form .dgwt-wcas-suggestions-wrapp").focusout(function() {
       $('.mobile_search_form').hide();


    });
  });

})(jQuery); // Fully reference jQuery after this point.




///////////////////////////////////////////

(function($) {
  $(document).ready(function() {

  /*=== Slick Sliders ===*/

    /*=== Stores slider ===*/
    if(window.location.href.indexOf("stores") > -1) {
      $('.store_container').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        autoplay: false,
        infinite: false,
        responsive: [
          {
          breakpoint: 950,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
          },
          {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
          },
          {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
          }
        ]
      });
    }




    /*=== Homepage, Upper ===*/
    $('.slider-home-upper--content').on('init', function(slick){
      $('.slider-home-upper--content').removeClass('hidden');
      $('.slider-home-upper--content').addClass('shown');
      console.log("unhide slider, home, upper");
    });

    $('.slider-home-upper--item--link').click(function() {
        var url = $(this).attr("data-url");
        console.log('linkypoo');
        console.log(url);
        window.location = url;
    });

    $('.slider-home-upper--content').slick({
      autoplay: false,
      arrows: true,
      prevArrow: '<button type="button" class="slick-prev slick-whitearrow"><div class="inner"></div></button>',
      nextArrow: '<button type="button" class="slick-next slick-whitearrow"><div class="inner"></div></button>',
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      // draggable: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            // dots: true
          }
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

  });
})(jQuery); // Fully reference jQuery after this point.